import {settingsRoutes} from '@dms/routes';

const salesServiceOrderVariantsRoutes = {
  overview: settingsRoutes.salesServiceOrderVariants,
  detail: settingsRoutes.salesServiceOrderVariantsDetail,
} as const;

const workshopServiceOrderVariantsRoutes = {
  overview: settingsRoutes.serviceOrderVariants,
  create: settingsRoutes.serviceOrderVariantsCreate,
  detail: settingsRoutes.serviceOrderVariantsDetail,
} as const;

const SALES_SERVICE_ORDER_VARIANTS_PREFIX = `${settingsRoutes.salesServiceOrderVariants}/`;

export function getServiceOrderVariantsRoutes(pathname: string) {
  if (
    pathname === settingsRoutes.salesServiceOrderVariants ||
    pathname.startsWith(SALES_SERVICE_ORDER_VARIANTS_PREFIX)
  ) {
    return salesServiceOrderVariantsRoutes;
  }

  return workshopServiceOrderVariantsRoutes;
}
